import PropTypes from "prop-types";

const QuizHeader = ({
  quizName,
  attemptNumber,
  totalQuestions,
  totalMarks,
  currentQuestion,
  answeredQuestions,
}) => {
  const safeTotalQuestions = Math.max(totalQuestions ?? 0, 0);

  const safeCurrentQuestion =
    safeTotalQuestions > 0
      ? Math.min(Math.max(currentQuestion ?? 0, 0), safeTotalQuestions)
      : 0;

  const safeAnsweredQuestions =
    safeTotalQuestions > 0
      ? Math.min(Math.max(answeredQuestions ?? 0, 0), safeTotalQuestions)
      : 0;

  return (
    <div
      className="bg-white rounded-lg shadow-sm border p-4 mb-4"
      aria-label="Quiz information"
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        {/* Quiz Information */}

        <div>
          <h2 className="text-xl font-semibold text-gray-800">
            {quizName || "Quiz"}
          </h2>

          <p className="text-sm text-gray-500 mt-1">
            Attempt #{attemptNumber ?? 1}
          </p>
        </div>

        {/* Quiz Stats */}

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          <div>
            <p className="text-xs text-gray-500">Questions</p>

            <p className="font-semibold text-gray-800">{safeTotalQuestions}</p>
          </div>

          <div>
            <p className="text-xs text-gray-500">Marks</p>

            <p className="font-semibold text-gray-800">{totalMarks ?? 0}</p>
          </div>

          <div>
            <p className="text-xs text-gray-500">Current</p>

            <p className="font-semibold text-blue-600">
              {safeCurrentQuestion}/{safeTotalQuestions}
            </p>
          </div>

          <div>
            <p className="text-xs text-gray-500">Answered</p>

            <p className="font-semibold text-green-600">
              {safeAnsweredQuestions}/{safeTotalQuestions}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

QuizHeader.propTypes = {
  quizName: PropTypes.string,

  attemptNumber: PropTypes.number,

  totalQuestions: PropTypes.number,

  totalMarks: PropTypes.number,

  currentQuestion: PropTypes.number,

  answeredQuestions: PropTypes.number,
};

QuizHeader.defaultProps = {
  quizName: "Quiz",

  attemptNumber: 1,

  totalQuestions: 0,

  totalMarks: 0,

  currentQuestion: 0,

  answeredQuestions: 0,
};

export default QuizHeader;
